import { render, staticRenderFns } from "./clientList.view.vue?vue&type=template&id=52c67e05&scoped=true&lang=pug"
import script from "./clientList.view.vue?vue&type=script&lang=ts"
export * from "./clientList.view.vue?vue&type=script&lang=ts"
import style0 from "./clientList.view.vue?vue&type=style&index=0&id=52c67e05&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c67e05",
  null
  
)

export default component.exports